import { render, staticRenderFns } from "./FmCheckbox.vue?vue&type=template&id=06df5a6a&"
import script from "./FmCheckbox.vue?vue&type=script&lang=js&"
export * from "./FmCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FmCheckbox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports